import { StorageAdapter, StorageCallback } from "../../storage/StorageAdapter";
import { BaseMarkdownStorageService, BaseStorageService } from "../StorageService";
import { StorageUploadFile } from "../../storage/common";
import { ILogger } from "../../utils/logger";
import { buildHelpArticleAssetsPath, buildHelpArticlePath } from "../../storage"

/** Takes care of all the media for help */
export class StorageHelpService extends BaseMarkdownStorageService {
    constructor(
        protected articleId: string,
        storageAdapter: StorageAdapter,
        logger?: ILogger,
    ) {
        super(storageAdapter, logger)
    }

    protected getBasePath(): string {
        return buildHelpArticlePath(this.articleId);
    }

    /*
     * Custom method to upload a md file
     */
    async uploadMdForHelp(
        contentMD: string,
        language_code?: string,
        callback?: StorageCallback
    ): Promise<{ path: string; url: string; size: number }> {
        return this
            .uploadMarkdown(
                contentMD,
                language_code,
                callback,
                {
                    articleId: this.articleId,
                });
    }
}

export class StorageHelpAssetService extends BaseStorageService {
    constructor(
        protected articleId: string,
        storageAdapter: StorageAdapter,
        logger?: ILogger,
    ) {
        super(storageAdapter, logger)
    }

    protected getBasePath(): string {
        return buildHelpArticleAssetsPath(this.articleId)
    }

    // Customize file size limit (20MB for help media)
    protected getMaxFileSize(): number {
        return 20 * 1024 * 1024; // 20MB
    }

    // Only allow images and videos
    protected getAllowedMimeTypes(): string[] {
        return [
            'image/jpeg',
            'image/png',
            'image/gif',
            'image/webp',
            'video/mp4',
            'video/quicktime',
        ];
    }

    /**
     * Custom method to upload an asset with help context
     */
    async uploadAssetForHelp(
        buffer: StorageUploadFile,
        filename: string,
        callback?: StorageCallback
    ): Promise<{ path: string; url: string; size: number }> {
        const result = await this
            .upload(buffer, filename, callback, {
                articleId: this.articleId,
                originalFileName: filename,
            });

        return result;
    }

    /** List all the medias associated to this help article */
    listMedias() {
        return this.listFiles(buildHelpArticleAssetsPath(this.articleId))
    }

    /** Delete all the medias associated to this help article */
    deleteAllMedias() {
        return this.deleteDirectory(buildHelpArticleAssetsPath(this.articleId))
    }
}